import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { RestResponse } from './core.model';
import 'rxjs/Rx';
import { NotificationService } from '../services/notification/notification.service';
import swal from 'sweetalert';

@Injectable()
export class RestService {
    constructor(
        private http: Http,
        private router: Router,
        private notificationService: NotificationService) { }

    public get<T>(path: string, showError: boolean = true): Observable<T> {
        const headers = new Headers();
        this.createHeaders(headers);
        return this.http.get(path, {
            headers: headers
        }).map((res: Response) => {
            return this.processResponse<T>(res, path);
        }).catch((error) => {
            if (showError) {
                var errorMessage = '';
                if (error.status === undefined)
                    errorMessage = `${error.message}`;
                else if (error.status === 403)
                    errorMessage = `Brak uprawnień: ${error.url}`;
                else if (error.status === 401)
                    errorMessage = null;
                else
                    errorMessage = `${error.status} - ${error.message}`;
                if (errorMessage !== null && errorMessage !== '' && !errorMessage.includes('pierwsze logowanie.'))
                    swal({ text: errorMessage });
            }

            if (error.status === 401) {
                this.navigateToLoginPage();
            }
            return Observable.throw(error);
        });
    }

    public post<T>(path: string, data: any, showError: boolean = true): Observable<T> {
        const headers = new Headers();
        this.createHeaders(headers);
        return this.http.post(path,
            JSON.stringify(data), {
            headers: headers
        }).map((res: Response) => {
            return this.processResponse<T>(res, path);
        }).catch((error) => {
            if (showError) {
                var errorMessage = '';
                if (error.status === undefined)
                    errorMessage = `${error.message}`;
                else if (error.status === 403)
                    errorMessage = `Brak uprawnień: ${error.url}`;
                else if (error.status === 401)
                    errorMessage = null;
                else
                    errorMessage = `${error.status} - ${error.message}`;
                if (errorMessage !== null && errorMessage !== '' && !errorMessage.includes('pierwsze logowanie.') && !errorMessage.includes('Użytkownik zewnętrzny. Należy wybrać kontrahenta.'))
                    sweetAlert({ text: errorMessage });
            }

            if (error.status === 401 || error.status === 404) {
                this.navigateToLoginPage();
            }

            return Observable.throw(error);
        });
    }

    private processResponse<T>(response: Response, path:string): T {
        if (response.status < 200) {
            throw Error('Bad response status: ' + response.status);
        }
        let responseContentType = response.headers.get('content-type');
        if(!responseContentType.includes('json')) {
            console.error('Path: \n' +  path + '\nResponse:\n' + response.text());
            throw Error('Bad response type: ' + responseContentType);
        }

        const restResponse: RestResponse<T> = response.json();
        if (restResponse.isSuccess) {
            if (restResponse.webToken) {
                localStorage.setItem('token', restResponse.webToken.accessToken);
                localStorage.setItem('refreshToken', restResponse.webToken.refreshToken);
            }
            return restResponse.data;
        } else {
            if (restResponse.errorMessage == 'Security error - context.')
                this.navigateToLoginPage();
            else if (restResponse.errorMessage.includes('pierwsze logowanie.')) {
                var loginStr = restResponse.errorMessage.split(':');
                this.router.navigate(['/changepassword', loginStr[0]]);
            }

            throw Error(restResponse.errorMessage);
        }
    }

    private createHeaders(headers: Headers) {
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        headers.append('Authorization', 'bearer ' + localStorage.getItem('token'));
        headers.append('RefreshToken', localStorage.getItem('refreshToken'));
    }

    private navigateToLoginPage() {
        this.router.navigate(['/login']);
    }
}
